const videosCmsEndpoint = '/api/cms/api/videos'
const videosHealthEndpoint = '/api/health/api/videos'

const getVideosbyCategory = async (categoryName: any) => {
    if (!categoryName) throw new Error('No category name provided')

    const query = new URLSearchParams({
        populate: '*',
        'filters[category][name][$eq]': categoryName,
        'filters[teams][teamId][$null]': 'true'
    })

    return await fetch(`${videosCmsEndpoint}?${query.toString()}`)
}

const getVideosByTeam = async (categoryName: any, team: any, token: any) => {
    if (!categoryName) throw new Error('No category name provided')
    if (!team) throw Error('No team provided')
    if (!token) throw Error('No token provided')

    return await fetch(`${videosHealthEndpoint}/contents/${categoryName}/${team}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
}

export { getVideosbyCategory, getVideosByTeam }